import { useRef } from 'react'
import PropTypes from 'prop-types'
import Input from 'components/forms/input'
import Clickable from 'components/clickable'
import css from '../store-search.scss'
import { searchStore } from '../helpers'
import { track, useTracking } from 'lib/analytics'

const addonStyle = {
  border: 'none',
  borderRadius: '0px',
  paddingRight: '0px',
  borderBottom: '1px solid black',
  paddingBottom: '0px',
}

const clearButtonStyle = {
  fontSize: '40px',
  color: '#6e3264',
  WebkitTextStroke: '5px white',
}

const SearchInput = ({
  searchString,
  setSearchString,
  closeModal,
  onKeyDown,
  inFocus,
}) => {
  const inputRef = useRef(null)
  const tracker = useTracking()
  const handleClear = () => {
    if (searchString) {
      setSearchString('')
      inputRef.current.focus()
    } else {
      closeModal()
    }
  }

  const trackSearchExecuted = () => {
    tracker.trackEvent({
      event: track.searchExecuted,
      searchTerm: searchString,
      eventType: track.EventType.SHOP,
    })
  }

  if (inFocus && inputRef.current) {
    inputRef.current.focus()
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        trackSearchExecuted()
        searchStore(searchString.trim(), closeModal)
      }}
      className={`input-search container ${css.searchInput}`}
    >
      <Input
        autoFocus
        inputRef={inputRef}
        value={searchString}
        onKeyDown={onKeyDown}
        aria-label="Search store"
        placeholder="What are you looking for?"
        groupStyle={{ margin: '36px 0px 0px' }}
        onChange={(e) => setSearchString(e.target.value)}
        addonStyle={addonStyle}
        maxLength="100"
        addonAfter={
          <Clickable onClick={handleClear}>
            <i
              className="fa fa-close"
              aria-label="Clear Search"
              style={clearButtonStyle}
            />
          </Clickable>
        }
      />
    </form>
  )
}

SearchInput.propTypes = {
  inFocus: PropTypes.bool.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  searchString: PropTypes.string.isRequired,
  setSearchString: PropTypes.func.isRequired,
}

export default SearchInput
